<template>
  <a
    :class="[hideIcon ? 'simple-btn' : 'btn', 'btn-gold', (isAlreadyAdded || cartIsFull) && 'btn-disabled', className]"
    @click.prevent.stop="addToCart()"
  >
    {{ hideIcon ? 'Add to Cart' : '' }}
    <span v-if="!hideIcon" class="btn-content">Add to Cart</span>
    <span v-if="!hideIcon" class="icon">
      <i :class="cartIsFull ? 'fas fa-check' : 'fas fa-shopping-cart'" aria-hidden="true"></i>
    </span>
  </a>
</template>

<script>
import { addToCartButtonMixin } from '../../shared/mixins/addToCartButtonMixin';

export default {
  mixins: [addToCartButtonMixin],

  props: {
    className: String,
    hideIcon: Boolean,
  },
};
</script>
